import SVG from "../../../Components/SVG";
import { useState } from "react";

export default function InputPW({
  label = "",
  inputSample = "",
  id = "",
  name = "",
  isReadOnly = true,
  isAuotComplete = false,
  isLTR = false,
  onChange,
  value,
  onBlur,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleToggle = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div
      className={`relative flex h-[42px] w-full items-center overflow-visible rounded-lg border transition-colors ${
        isReadOnly
          ? "border-transparent bg-transparent"
          : "border-zi-border-light bg-transparent dark:border-none dark:bg-zi-inputbg-dark hocus-within:border-zi-border-dark hocus-within:dark:border-zi-border-dark/50"
      }`}
    >
      <input
        defaultValue={inputSample}
        type={showPassword ? "text" : "password"}
        id={id}
        name={name}
        readOnly={isReadOnly}
        autoComplete={isAuotComplete}
        className={`zi-input-autofill h-full w-full bg-transparent py-0 pl-11 pr-3 text-start text-sm text-zi-text-light outline-none dark:text-zi-text-dark ${
          isLTR ? "[direction:ltr]" : "[direction:rtl]"
        }`}
        onChange={onChange}
        onBlur={(event) => {
          onBlur?.(event);
        }}
        value={value}
      />
      {label && (
        <label
          htmlFor={id}
          className={`zi-floating-label pointer-events-none absolute right-0 top-0 z-10 origin-right -translate-y-1/2 rounded-lg rounded-b-none px-2.5 py-1 text-xs leading-none text-zi-blue-light transition-colors duration-200 ease-in-out dark:text-zi-text-dark ${
            !isReadOnly ? "dark:bg-zi-inputbg-dark" : "bg-transparent"
          }`}
        >
          {label}
        </label>
      )}
      <button
        type="button"
        tabIndex="-1"
        onClick={handleToggle}
        className={`absolute left-1 top-1/2 z-20 -translate-y-1/2 p-2 ${
          isReadOnly ? "pointer-events-none opacity-0" : "opacity-100"
        }`}
        aria-label={showPassword ? "مخفی کردن رمز عبور" : "نمایش رمز عبور"}
      >
        <SVG
          name={showPassword ? "eye" : "eyeClosed"}
          classname={
            showPassword
              ? "stroke-zi-blue-dark dark:stroke-white"
              : "fill-zi-blue-dark dark:fill-white"
          }
        />
      </button>

      <style>
        {`
            input[type="password"]::-ms-reveal,
            input[type="password"]::-ms-clear {
              display: none !important;
            }
            input[type="password"]::-webkit-textfield-decoration-container {
              display: none;
            }
            input[type="password"]::-webkit-search-decoration {
              display: none;
            }
          `}
      </style>
    </div>
  );
}
